import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Cookies from "js-cookie";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Container,
  Box,
  CircularProgress,
} from "@mui/material";
import axios from "axios";
import AppGlobalStaticData from "../appdata/appStaticData";
import AutohideSnackbar from "../components/LayoutModule/autohideSnackbar";

// Import Icons
import {
  Gavel,
  PendingActions,
  CheckCircle,
  Balance,
  Business,
} from "@mui/icons-material";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const HomePage = () => {
  const navigate = useNavigate();
  const [dashboardData, setDashboardData] = useState([
    {
      Count: 0,
      URL: "/case/list",
      Heading: "Case Count",
      section: "caseCount",
      icon: <Gavel fontSize="large" sx={{ color: "#E67E22" }} />,
    },
    {
      Count: 0,
      URL: "/case/edit",
      Heading: "Pending",
      section: "pendingCaseCount",
      icon: <PendingActions fontSize="large" sx={{ color: "#F39C12" }} />,
    },
    {
      Count: 0,
      URL: "/case/disposed-decreed",
      Heading: "Decreed",
      section: "decreedCaseCount",
      icon: <CheckCircle fontSize="large" sx={{ color: "#27AE60" }} />,
    },
    {
      Count: 0,
      URL: "/case/disposed-decreed",
      Heading: "Disposed",
      section: "disposedCaseCount",
      icon: <Balance fontSize="large" sx={{ color: "#2980B9" }} />,
    },
    {
      Count: 0,
      URL: "/courts",
      Heading: "Court",
      section: "CourtList",
      icon: <Business fontSize="large" sx={{ color: "#8E44AD" }} />,
    },
  ]);

  const [snackbarProperties, setSnackbarProperties] = useState({
    duration: 0,
    message: "",
    severity: "",
  });
  const [loading, setLoading] = useState(false);
  const globalData = new AppGlobalStaticData();

  useEffect(() => {
    const token = Cookies.get("auth_token");
    if (!token) {
      setTimeout(() => {
        navigate("/login");
      }, 1000);
    } else {
      fetchDashboardData();
    }
  }, [navigate]);

  const fetchDashboardData = async () => {
    setLoading(true);
    const today = new Date();
    const dd = String(today.getDate() - 1).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const yyyy = today.getFullYear();
    const date = `${yyyy}-${mm}-${dd}`;
    try {
      const token = Cookies.get("auth_token");
      const response = await axios.get(
        `${API_BASE_URL}/api/v1/case-details/dashboard`,
        {
          params: { end_date: date },
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data.status === "Success") {
        const updatedData = dashboardData.map((item) => ({
          ...item,
          Count: response.data.data[item.section] || 0,
        }));

        setDashboardData(updatedData);
        setSnackbarProperties({
          duration: globalData.Duration,
          message: globalData.HomePageDashboardContentFailed,
          severity: globalData.SeveritySuccess,
        });
      } else {
        setSnackbarProperties({
          duration: globalData.Duration,
          message: globalData.HomePageDashboardContentFailed,
          severity: globalData.SeverityError,
        });
        console.error("Failed to fetch cases");
      }
    } catch (error) {
      setSnackbarProperties({
        duration: globalData.Duration,
        message: globalData.HomePageDashboardContentFailed,
        severity: globalData.SeverityError,
      });
      console.error("Error fetching cases:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
        <Typography variant="h6" sx={{ marginLeft: 2 }}>
          Loading Dashboard...
        </Typography>
      </Box>
    );
  }

  return (
    <Container sx={{ pt: "40px", flexGrow: 1 }}>
      <Grid container spacing={3} justifyContent="center" pt={2}>
        {dashboardData.map((value, index) => (
          <Grid item xs={12} sm={6} md={4} lg={2.4} mt={3} key={index}>
            <Link
              to={value.URL}
              style={{ textDecoration: "none" }}
              aria-label={`View ${value.Heading}`}
            >
              <Card
                sx={{
                  borderRadius: "12px",
                  boxShadow: 2,
                  textAlign: "center",
                  transition: "0.3s",
                  "&:hover": { boxShadow: 5, transform: "translateY(-5px)" },
                }}
              >
                <CardContent>
                  {value.icon}
                  <Typography variant="h6" sx={{ marginTop: 1 }}>
                    {value.Heading}
                  </Typography>
                  <Typography
                    variant="h4"
                    sx={{ fontWeight: "bold", marginTop: 1 }}
                  >
                    {value.Count}
                  </Typography>
                </CardContent>
              </Card>
            </Link>
          </Grid>
        ))}
      </Grid>
      <AutohideSnackbar
        duration={snackbarProperties.duration}
        message={snackbarProperties.message}
        severity={snackbarProperties.severity}
      />
    </Container>
  );
};

export default HomePage;
